import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { MaintenanceWindowManuallyApprovedPatchesSelectorWebComponentViewData, ManuallyApprovedPatch } from '../types';
import { GzEnumFilterWebComponent } from '../../../ui/gzEnumFilter';
import { translateFn } from '../../../utils/translator.helper';
import { GzFormFieldWebComponent } from '../../../ui/gzForm/formField';
import { LabelWidthValues } from '../../../types/common/types';
import { RequiredValidator } from '../../../ui/gzForm/validators/required.validator';
import { EnumListItem } from '../../../ui/gzEnumList/types';

export class MaintenanceWindowManuallyApprovedPatchesSelectorView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $patchesFormField: GzFormFieldWebComponent;
    $patchesSelector: GzEnumFilterWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $patchesFormField: this.shadow.querySelector('#manually-approved-patches-form-field'),
      $patchesSelector: this.shadow.querySelector('#manually-approved-patches-selector'),
    };
  }

  setTranslatedStrings() {
    this.dom.$patchesSelector.label = translateFn('Patches with manual approval');
    this.dom.$patchesSelector.confirmActionButtonString = translateFn('Apply');
    this.dom.$patchesSelector.searchPlaceholderString = translateFn('Search');
    this.dom.$patchesSelector.noSearchResultsString = translateFn('No patches');
    this.dom.$patchesSelector.placeholder = translateFn('Select patches');
    this.dom.$patchesSelector.allItemsLabel = translateFn('All patches');
  }

  buildSuccessView(data: MaintenanceWindowManuallyApprovedPatchesSelectorWebComponentViewData) {
    this.setTranslatedStrings();

    const selectorOptions = this.convertManuallyApprovedPatchesToSelectorOptions(data.availablePatches);
    this.updateSelectedPatches(selectorOptions, data.selectedPatchIds);

    this.dom.$patchesSelector.allowSelectNone = true;
    this.dom.$patchesSelector.isClearable = true;
    this.dom.$patchesSelector.filterOptions = selectorOptions;
    this.dom.$patchesSelector.labelWidth = LabelWidthValues.LARGE;

    this.dom.$patchesFormField.Validators = [RequiredValidator(translateFn('Select at least one patch.'))];
  }

  buildErrorView() {}

  public getFormField(): GzFormFieldWebComponent {
    return this.dom.$patchesFormField;
  }

  public setDisabledInnerComponents(value: boolean) {
    this.dom.$patchesSelector.disabled = value;
  }

  public validateFormField() {
    // We want to show the validation error from the very beginning if applicable (markAsTouched: true)
    this.dom.$patchesFormField.validate(true);
  }

  private convertManuallyApprovedPatchesToSelectorOptions(patches: ManuallyApprovedPatch[]): EnumListItem[] {
    return patches.map((patch: ManuallyApprovedPatch) => {
      const ignoredPatchLabel = translateFn('[ignored] {manuallyApprovedPatchName}', {
        manuallyApprovedPatchName: patch.name,
      });

      return {
        id: patch._id,
        label: patch.isIgnored ? ignoredPatchLabel : patch.name,
        value: patch.patchId,
        selected: false,
        disabled: false,
        readonly: false,
      } as EnumListItem;
    });
  }

  private updateSelectedPatches(selectorOptions: EnumListItem[], patchIds: string[]): void {
    selectorOptions.forEach(option => {
      const currentOptionPatchId = option.value.toString();
      if (patchIds.includes(currentOptionPatchId)) {
        option.selected = true;
      }
    });
  }
}
